import type {Integer, Iso8601Date, Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export type OttopilotContest = {
    id: Uuid;
    createdBy: Uuid;
    createdAt: Iso8601DateTime;
    updatedBy: Uuid;
    updatedAt: Iso8601DateTime;
    status: OttopilotContestStatus;
    revisionId: Uuid;
    title: string;
    description: string;
    startDate: Iso8601Date;
    endDate: Iso8601Date;
    bannerImageUrl: string;
    termsAndConditions: string;
    eligibleUserTemplateIds: Array<Uuid>;
    payoutCurrencyId: Uuid;
    payoutPointValue: number;
    kpis: Array<{
        id: Uuid;
        eventTemplateId: Uuid;
        dispositionId: Uuid;
        reward: number;
        limit: Integer;
    }>;
    proposedBudget: number;
    workspaceId: Uuid;
};

export enum OttopilotContestStatus {
    active = "043f0b03-76e7-40ca-8c05-36295ebaa587",
    archived = "859245c6-1559-4ab4-83f7-eebbe5f52d84",
    draft = "e1b87fc0-fde8-4268-b4dd-91a41eecec20",
}
